import React from "react";
import data from "../../json/Contactus/Contactus1.json";
import { Link } from "react-router-dom";

const Contactus1 = () => {
  return (
    <div className="w-full flex justify-center">
      <div className="w-full 2xl:container md:px-10 lg:px-20  px-6 md:py-20 py-[64px]">
        <div className="w-full flex flex-col items-center gap-4">
          <h1 className="text-32 md:text-48 lg:text-64 text-primarycolor text-center font-semibold">
            {data.Title}
          </h1>
          <p className="text-base md:text-18 text-secondaryblack font-regular">
            {data.subtitle}
          </p>
        </div>
        <div className="mt-12 sm:mt-16 grid gap-[31px] xl:grid-cols-3 lg:grid-cols-2 grid-cols-1 max-md:place-items-center">
          {data.countries.map((item, i) => (
            <div
              key={i}
              className="   w-full h-auto  flex  flex-col gap-4 p-4 sm:gap-6 sm:p-8 rounded-[24px] border-[1px] border-journyborder shadow-services"
            >
              <div className="flex gap-4 items-center">
                <img
                  src={process.env.PUBLIC_URL + item.icon}
                  className="sm:h-12 sm:w-12 h-10 w-10"
                  alt="location_icon"
                />
                <h1 className=" text-24 md:text-32 font-semibold text-primarycolor">
                  {item.country}
                </h1>
              </div>
              <div className="flex flex-col gap-6 justify-between h-full">
              <p className=" text-16 md:text-18 text-secondaryblack">
                {item.address}
              </p>
              <div className="flex flex-col justify-start gap-4">
                <div className="phoneicon flex items-center gap-4">
                  <a
                    href={`tel:${item.Phone.replace(/[^+\d]/g, "")}`}
                    className="text-16 md:text-18 font-medium text-sendaryblack "
                  >
                    {item.Phone}
                  </a>
                </div>
                {item.whatsapp && (
                  <div className="whatsappicon flex items-center gap-4  ">
                    <a
                      href={`https://wa.me/${item.whatsapp.replace(
                        /[^+\d]/g,
                        ""
                      ).replace("+", "")}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-16 md:text-18 font-medium text-sendaryblack"
                    >
                      {item.Phone}
                    </a>
                  </div>
                )}
                {item.Phone1 && (
                  <div className="phoneicon flex items-center gap-4  ">
                    <a
                      href={`tel:${item.Phone1.replace(/[^+\d]/g, "")}`}
                      className="text-16 md:text-18 font-medium text-sendaryblack "
                    >
                      {item.Phone1}
                    </a>
                  </div>
                )}
 {i==2 && (
                  <div className="max-lg:hidden lg:h-[26px]  ">
                  
                  </div>
                )}


              </div>
             
              </div>
               <Link
                to={item.map}
                target="_"
                className="googlelink bio font-semibold mt-2"
              >
                View on Google Maps
              </Link>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Contactus1;
